export const get_countries = (get_countries) => {
  let countries = [];
  const objectArray = Object.entries(get_countries || {});
  // eslint-disable-next-line no-unused-vars
  objectArray.forEach(([key, value]) => {
    countries.push({ value: key, text: value });
  });
  return countries;
};
